export const genderTitleMap = {
  MR: "Male",
  MRS: "Male",
  MS: "Female",
}
